//引入axios
import axios from 'axios'
import qs from 'qs'
import router from '../router'
// import router from './router'

//服务器切换
const IP = '../qvad-release-api/';  // 线上
// const IP = 'http://192.168.1.236:8000/qvad-release-api/';  // 测试
// const IP = 'http://localhost:8091/qvad_release_api/';  // 开发
//
// axios 配置
axios.defaults.timeout = 10000
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true
axios.defaults.baseURL = IP;

//请求之前处理参数
//添加loading状态
axios.interceptors.request.use((config) => {
  if (config.method === 'post' && config.headers.hasOwnProperty('Content-Type')) {
    config.data = JSON.stringify(config.data)
  } else if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  } else if (config.method === 'get' && config.headers.hasOwnProperty('Content-Type')) {
    config.data = JSON.stringify(config.data)
  } else if (config.method === 'get') {
    config.data = qs.stringify(config.data)
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

//统一处理返回状态
axios.interceptors.response.use(config => {
  if (config.data.status == -1) {
    //未登录暂不统一处理
    localStorage.removeItem("userInfo");
    // this.$route.push({path:'/'})
    // window.location.href = "/"
  } else if (config.data.status == '0') {
    // msgError('系统异常！');
  }
  return config
}, error => {
  return Promise.reject(error)
});

//post请求头一
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


// post请求头二
export function fetch(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params })
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
let commonApi = {
  getHomepageCases(p) {
    return get('api/getHomepageCases', p)
  },
  postRequirement(p) {
    return post('api/postRequirement', p)
  },
  getCasesList(p) {
    return get('api/getCasesList', p)
  },
  getCases(p) {
    return get('api/getCases', p)
  },
  login(p) {
    return post('api/login', p)
  },
  register(p) {
    return post('api/register', p)
  },
  resetPassword(p) {
    return post('api/resetPassword', p)
  },
  getSmsCode1(p) {
    return get('api/getSmsCode1', p)
  },
  getSmsCode2(p) {
    return get('api/getSmsCode2', p)
  },
  // api/getOssCloudName
  getOssCloudName(p) {
    return get('api/getOssCloudName', p)
  },
}
const indexApi = {

  queryADList(p) {
    return get('api/account/getAdInfoList', p)
  },
  getAppType(p) {
    return get('/api/getAppType', p)
  },
  // getAppTypeList
  getAppTypeList(p) {
    return get('/api/getAppTypeList', p)
  },
  getMaterialType(p) {
    return get('/api/getMaterialType', p)
  },
  getIndustryTypeList(p) {
    return get('/api/getIndustryTypeList', p)
  },
  getTagList(p) {
    return get('/api/getTagList', p)
  },
  getDistricts(p) {
    return get('/api/getDistricts', p)
  },
  getAdtype(p) {//获取广告推荐位
    return get('/api/getAdtype', p)
  },
  getSheetDataByDate(p) {//获取广告推荐位
    return get('/api/account/getSheetDataByDate', p)
  },
  deleteAdInfo(p) {
    return get('/api/account/deleteAdInfo', p)
  },
  changeAdStatus(p) {
    return get('/api/account/changeAdStatus', p)
  },
  postAdTemplate(p) {
    return post('/api/account/postAdInfo', p)
  },
  getAdInfo(p) {
    return get('/api/account/getAdInfo', p)
  },
  getAdInfoTotal(p) {
    return get('/api/account/getAdInfoTotal', p)
  },
  getDetail(p) {
    return get('/api/account/getDetail', p)
  },
  logout(p) {
    return post('/api/logout', p)
  },
  exportAdInfoExcel(p) {
    return get('/api/account/exportAdInfoExcel', p)
  },
  getReportChartData(p) {
    return get('/api/account/getReportChartData', p)
  },
  getReportDetailData(p) {
    return get('/api/account/getReportDetailData', p)
  },
  exportReportExcel(p) {
    return get('/api/account/exportReportExcel', p)
  },
  getReportTotal(p) {
    return get('/api/account/getReportTotal', p)
  },
  getAllAdInfo(p) {
    return get('/api/account/getAllAdInfo', p)
  },
  getAdTemplate(p) {
    return get('/api/account/getAdTemplate', p)
  },
  getAdTemplateList(p) {
    return get('/api/account/getAdTemplateList', p)
  },
  deleteAdTemplate(p) {
    return get('/api/account/deleteAdTemplate', p)
  },
  postAdTemplates(p) {
    return post('/api/account/postAdTemplate', p)
  },
  //对账链接
  jumpToReconciliationSystem(p){
    return get('/api/account/jumpToReconciliationSystem', p)
  }
}

let HomeApi = {
  getAccountHomePageInfo() {
    return get('api/account/getAccountHomePageInfo', '')
  },
  getAccountHomePageStatistics(params) {
    return get('api/account/getAccountHomePageStatistics', params)
  },

  exportHomePageStatisticsExcel(params) {
    return get('api/account/exportHomePageStatisticsExcel', params)
  },
}
let FinanceApi = {
  charge(params) {
    return fetch('api/account/charge', params)
  },
  getAdFinanceList(params) {
    return get('api/account/getAdFinanceList', params)
  },
  getTurnoverData(params) {
    return get('api/account/getTurnoverData', params)
  },
  exportTurnoverData(params) {
    return get('api/account/exportTurnoverData', params)
  },

  getSheetRecord(params) {
    return get('api/account/getSheetRecord', params)
  },
  // api/account/getTurnoverData
  getChargeList(params) {
    return get('api/account/getChargeList', params)
  },
  getPayResult(params) {
    return get('api/account/getPayResult', params)
  },
}

let AccountApi = {
  getDetail() {
    return get('api/account/getDetail', '')
  },
  postAuth(params) {
    return post('api/account/postAuth', params)
  },
  editAccount(params) {
    return post('api/account/editAccount', params)
  },
  changePassword(params) {
    return post('api/account/changePassword', params)
  },
}

let MessageApi = {
  getMsgList(params) {
    return get('api/account/getMsgList', params)
  },
  setMsgRead(params) {
    return get('api/account/setMsgRead', params)
  }
}

export {
  commonApi,
  indexApi,
  HomeApi,
  FinanceApi,
  IP,
  AccountApi,
  MessageApi
}



// WEBPACK FOOTER //
// ./src/axios/index.js